import {Component, OnInit, ViewChild} from '@angular/core';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState} from '../../../store/app.states';
import {DoctorService} from '../../../services/doctor.service';
import {DialogService} from '../../../services/dialog.service';
import {MatDialog} from '@angular/material/dialog';
import {HttpClient} from '@angular/common/http';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Observable} from 'rxjs';
import {InactivePatient} from '../../../model/user/InactivePatient';
import {MatTableDataSource} from '@angular/material/table';
import {QuestionnaireNotRead} from '../../../model/questionnaires/questionnaire-not-read';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {ConfirmDialogComponent} from '../../user-actions/confirm-dialog/confirm-dialog.component';
import {Router} from '@angular/router';
import {ErrorDialogComponent} from '../../user-actions/error-dialog/error-dialog.component';

@Component({
  selector: 'app-inactive-patients-summary',
  templateUrl: './inactive-patients-summary.component.html',
  styleUrls: ['./inactive-patients-summary.component.css']
})

/* Questo componente contiene la pagina dove vengono indicati al dottore loggato i suoi pazienti inattivi
* e cioè coloro che non si collegano alla piattaforma da diverso tempo. */
export class InactivePatientsSummaryComponent implements OnInit {
  getAuthState: Observable<any>;
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  destination = 'patients-control-panel';
  title = 'Questionari da visionare';

  notReady = false; // permette la visualizzazione della barra di caricamento nella tabella.

  inactivePatients: InactivePatient[];
  displayedColumns: string[] = ['name', 'surname', 'category', 'lastLogin', 'card', 'questionnaires', 'remove'];
  dataSource = new MatTableDataSource<InactivePatient>();
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  constructor(private store: Store<AppState>,
              private doctorService: DoctorService,
              private dialogService: DialogService,
              private router: Router,
              public dialog: MatDialog) {
    this.getAuthState = this.store.select(selectAuthState);
  }

  ngOnInit(): void {
    this.getAuthState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.user = JSON.parse(localStorage.getItem('user'));
      this.errorMessage = state.errorMessage;

      // Si fa la richiesta per ottenere i pazienti inattivi così da creare la tabella
      if (this.inactivePatients === [] || this.inactivePatients === undefined || this.inactivePatients === null) {
        this.notReady = true;
        this.doctorService.getInactivePatients().subscribe(
          inactivePatients => {
            console.log(inactivePatients);
            this.updateTable(inactivePatients);
            if (this.inactivePatients !== [] && this.inactivePatients != null) {
              this.notReady = false;
            }
          });
      }
    });
  }

  // ogni modifica della tabella richiede di fare le seguenti operazioni che coinvolgono il sorting
  // e la divisione in pagine (paginator) della tabella
  updateTable(inactivePatients: InactivePatient[]) {
    this.inactivePatients = inactivePatients;
    this.dataSource = new MatTableDataSource<InactivePatient>(this.inactivePatients);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sortingDataAccessor = (data: any, sortHeaderId: string): string => {
      if (typeof data[sortHeaderId] === 'string') {
        return data[sortHeaderId].toLocaleLowerCase();
      }
      return data[sortHeaderId];
    };
    this.dataSource.sort = this.sort;
  }

  // ci porta alla pagina che elenca i questionari completati dal paziente indicato
  goToQuestionnaires(patient: InactivePatient) {
    this.router.navigateByUrl('/patient-questionnaire-panel/' + patient.ssn + '/inactive-patients-summary');
  }

  // apre la dialog per eliminare un paziente. Copiata da quella già presente in patients-control-panel
  openDeleteDialog(patient) {
    const message = 'Se confermata, questa operazione non potrà più essere annullata e il paziente verrà eliminato dal nostro sistema.';
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      height: '265px',
      data: message
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'SI') {
        this.doctorService.removePatient(patient).subscribe(d => {
            if (d.status === 200) {
              this.inactivePatients.forEach( (p, index) => {
                if (p.ssn.localeCompare(patient.ssn) === 0) {
                  this.inactivePatients.splice(index, 1);
                }
              });
              this.updateTable(this.inactivePatients);
            }
          },
          error => {
            console.log(error);
            this.openErrorDialog('Qualcosa è andato storto. Le modifiche non verranno salvate.');
          });
      }
    });
  }

  openErrorDialog(message: string): void {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '500px',
      height: '270px',
      data: message
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Finestra chiusa');
    });
  }

  // porta alla scheda con i dati personali del paziente.
  openPanel(patient) {
    this.router.navigateByUrl('/patient-panel/' + patient.ssn + '/inactive-patients-summary');
  }
}
